module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"headTitle":"Start vragenlijst","headDescription":"We gaan je nu een paar vragen stellen. Hierdoor kunnen we makelaars vinden die bij jou passen.","pill":"Makelaars vergelijken in 1 minuut","title":"We gaan je nu een paar vragen stellen. Hierdoor kunnen we makelaars vinden die bij jou passen.","nextBtn":"Ga verder","subtext":"Gratis & volledig vrijblijvend"}}')
  delete Component.options._Ctor
}
